// src/components/pages/Pessoa/tabs/PessoaTabNomes.jsx

import React from 'react';
import { ThemeProvider } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { Box, Button, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

import Input from '../../../form/Input';
import Select from '../../../form/Select';
import Checkbox from '../../../form/Checkbox';

import { podeEditarItem, podeCancelarItem } from '../../../../hooks/usePermisionMRT';
import { usePessoaNomeModule } from '../modules/usePessoaNomeModule';

const PessoaTabNomes = ({ theme, module, mrt, EnumOrigem }) => {
    const { items, rowCount, isLoading, isRefetching, isError, novoNome } = module.state;
    const { change, focus, blur, limpar, submit, handleEditarOuDeletar } = module.actions;
    const columns = module.columns;

    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <Input
                    text="Novo Nome"
                    type="text"
                    name="novoNome.nome"
                    placeholder="Nome"
                    inputWidth="300px"
                    title="Digite o novo nome da pessoa"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoNome.nome || ''}
                />

                <Select
                    name="novoNome.origem"
                    text="Origem"
                    options={EnumOrigem}
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoNome.origem || ''}
                    isEnum={true}
                />

                <Input
                    text="Data Nome"
                    type="date"
                    name="novoNome.data"
                    placeholder="Data"
                    title="Data da alteração do nome"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoNome.data || ''}
                />

                <Checkbox
                    title="Quando marcado torna o nome ativo"
                    text="Ativo"
                    name="novoNome.ativo"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoNome.ativo}
                    checked={!!novoNome.ativo}
                />

                <Button variant="contained" color="inherit" onClick={limpar} style={{ marginLeft: '10px' }}>
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={String(novoNome.funcao).toLowerCase() === 'deletar' ? 'error' : 'info'}
                    onClick={submit}
                    disabled={!novoNome.nome}
                    style={{ marginLeft: '5px' }}
                >
                    {novoNome.funcao}
                </Button>
            </Box>

            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: { align: 'center' },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true,
                            enableResizing: true,
                            muiTableHeadCellProps: { sx: { fontSize: '1.2rem' } },
                        },
                        'mrt-row-select': {
                            enableColumnActions: false,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <span>
                                    <IconButton
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Editar')}
                                        disabled={!podeEditarItem()}
                                    >
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Deletar')}
                                        disabled={!podeCancelarItem()}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    columns={columns}
                    data={items}
                    rowCount={rowCount}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={mrt.setColumnFilters}
                    onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                    onGlobalFilterChange={mrt.setGlobalFilter}
                    onPaginationChange={mrt.setPagination}
                    onSortingChange={mrt.setSorting}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                    }}
                    state={{
                        columnFilterFns: mrt.columnFilterFns,
                        columnFilters: mrt.columnFilters,
                        globalFilter: mrt.globalFilter,
                        isLoading,
                        pagination: mrt.pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting: mrt.sorting,
                    }}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};

export default React.memo(PessoaTabNomes);
